/* eslint-disable @typescript-eslint/no-explicit-any */
import { dashboard } from 'types';
import { toJSONArray } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

interface State {
  connectedSystems: dashboard.ConnectedExternalSystem[] | null;
  checks: dashboard.IPosCheck[] | null;
  numResults?: number;
  isInitialized: boolean;
  isRequestInProgress: boolean;
  visits: dashboard.IVisitSummary[] | null;
  error?: any;
  variable?: any;
}

const initialState = {
  connectedSystems: null,
  checks: null,
  isInitialized: false,
  isRequestInProgress: false,
  visits: null,
};

export default function reducer(state: State = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.POS_SEARCH_CHECKS_DONE: {
      payload.posCheck = toJSONArray<dashboard.IPosCheck>(payload.posCheck);
      return {
        ...state,
        checks: payload,
        numResults: payload.count,
        isInitialized: true,
        isRequestInProgress: false,
        error: null,
      };
    }
    case AppConstants.POS_SEARCH_DAY_VISITS_DONE: {
      return {
        ...state,
        visits: payload,
        isInitialized: true,
        isRequestInProgress: false,
        error: null,
      };
    }
    case AppConstants.POS_ASSOCIATE_CHECK_DONE:
    case AppConstants.POS_EXCLUDE_CHECK_DONE: {
      return {
        ...state,
        variable: payload,
        isInitialized: true,
        isRequestInProgress: false,
        error: null,
      };
    }
    case AppConstants.POS_LIST_CONNECTED_DONE: {
      return {
        ...state,
        connectedSystems: toJSONArray(payload),
        isInitialized: true,
        isRequestInProgress: false,
        error: null,
      };
    }
    case AppConstants.POS_CONNECT_DONE: {
      return {
        ...state,
        isInitialized: true,
        isRequestInProgress: false,
        error: null,
      };
    }
    case AppConstants.POS_CONNECT_STARTING:
    case AppConstants.POS_SEARCH_CHECKS_STARTING:
    case AppConstants.POS_SEARCH_DAY_VISITS_STARTING:
    case AppConstants.POS_ASSOCIATE_CHECK_STARTING:
    case AppConstants.POS_EXCLUDE_CHECK_STARTING: {
      return {
        ...state,
        isRequestInProgress: true,
        isInitialized: false,
      };
    }
    case AppConstants.POS_CONNECT_FAILED: {
      return {
        ...state,
        isRequestInProgress: false,
        isInitialized: true,
        error: 'Unable to connect to POS. Double check your username and password and try again.',
      };
    }
    case AppConstants.POS_SEARCH_CHECKS_FAILED:
    case AppConstants.POS_SEARCH_DAY_VISITS_FAILED:
    case AppConstants.POS_ASSOCIATE_CHECK_FAILED:
    case AppConstants.POS_EXCLUDE_CHECK_FAILED: {
      return {
        ...state,
        isRequestInProgress: false,
        isInitialized: true,
        error: 'Unable to load data. Please try again.',
      };
    }
    default:
      return state;
  }
}
